<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 7H20.5M15 6.53571L15 4C15 3.44771 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4L9.00001 6.53571"
        stroke="var(--icon-color)" stroke-width="2" stroke-linecap="round" />
    <path d="M6 9L6 19.5C6 20.6046 6.89543 21.5 8 21.5L16 21.5C17.1046 21.5 18 20.6046 18 19.5L18 9" stroke="var(--icon-color)"
        stroke-width="2" />
</svg>
